/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { RetornoLogradouros } from '../models/retorno-logradouros';
import { RetornoLogradouro } from '../models/retorno-logradouro';

/**
 * API para integracao com o servico corporativo Logradouros
 */
@Injectable({
  providedIn: 'root',
})
class GuiaPostalService extends __BaseService {
  static readonly obterLogradourosPath = '/logradouros';
  static readonly obterLogradouroPorCodigoPath = '/logradouro';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera uma lista de logradouros filtrando por pelo nomeLogradouro, numeroCepLogradouro, numeroCepComplementoLogradouro, codigoLocalidade e/ou codigoEstado
   * @param params The `GuiaPostalService.ObterLogradourosParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `numeroCepLogradouro`:
   *
   * - `numeroCepComplementoLogradouro`:
   *
   * - `nomeLogradouro`:
   *
   * - `codigoLocalidade`:
   *
   * - `codigoEstado`:
   *
   * @return Lista de logradouros recuperada
   */
  obterLogradourosResponse(params: GuiaPostalService.ObterLogradourosParams): __Observable<__StrictHttpResponse<RetornoLogradouros>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.perPage != null) __params = __params.set('per_page', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    if (params.numeroCepLogradouro != null) __params = __params.set('numeroCepLogradouro', params.numeroCepLogradouro.toString());
    if (params.numeroCepComplementoLogradouro != null) __params = __params.set('numeroCepComplementoLogradouro', params.numeroCepComplementoLogradouro.toString());
    if (params.nomeLogradouro != null) __params = __params.set('nomeLogradouro', params.nomeLogradouro.toString());
    if (params.codigoLocalidade != null) __params = __params.set('codigoLocalidade', params.codigoLocalidade.toString());
    if (params.codigoEstado != null) __params = __params.set('codigoEstado', params.codigoEstado.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/logradouros`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<RetornoLogradouros>;
      })
    );
  }
  /**
   * Recupera uma lista de logradouros filtrando por pelo nomeLogradouro, numeroCepLogradouro, numeroCepComplementoLogradouro, codigoLocalidade e/ou codigoEstado
   * @param params The `GuiaPostalService.ObterLogradourosParams` containing the following parameters:
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `numeroCepLogradouro`:
   *
   * - `numeroCepComplementoLogradouro`:
   *
   * - `nomeLogradouro`:
   *
   * - `codigoLocalidade`:
   *
   * - `codigoEstado`:
   *
   * @return Lista de logradouros recuperada
   */
  obterLogradouros(params: GuiaPostalService.ObterLogradourosParams): __Observable<RetornoLogradouros> {
    return this.obterLogradourosResponse(params).pipe(
      __map(_r => _r.body as RetornoLogradouros)
    );
  }

  /**
   * Recupera um logradouro por codigo da localidade
   * @param codigoLocalidade undefined
   * @return Logradouro
   */
  obterLogradouroPorCodigoResponse(codigoLocalidade: string): __Observable<__StrictHttpResponse<RetornoLogradouro>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (codigoLocalidade != null) __params = __params.set('codigoLocalidade', codigoLocalidade.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/logradouro`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<RetornoLogradouro>;
      })
    );
  }
  /**
   * Recupera um logradouro por codigo da localidade
   * @param codigoLocalidade undefined
   * @return Logradouro
   */
  obterLogradouroPorCodigo(codigoLocalidade: string): __Observable<RetornoLogradouro> {
    return this.obterLogradouroPorCodigoResponse(codigoLocalidade).pipe(
      __map(_r => _r.body as RetornoLogradouro)
    );
  }
}

module GuiaPostalService {

  /**
   * Parameters for obterLogradouros
   */
  export interface ObterLogradourosParams {
    perPage?: number;
    page?: number;
    numeroCepLogradouro?: string;
    numeroCepComplementoLogradouro?: string;
    nomeLogradouro?: string;
    codigoLocalidade?: string;
    codigoEstado?: string;
  }
}

export { GuiaPostalService }
